import {
  type FormContext,
  type GenericObject,
  useForm as vUseForm,
} from 'vee-validate';
import type { PartialDeep } from 'type-fest';
import { computed, type ComputedRef } from 'vue';

export type Form<T extends GenericObject> = {
  isValid: ComputedRef<boolean>;
  formValues: ComputedRef<T>;
  vForm: FormContext<T, T>;
};

export const useForm: <T extends GenericObject>(initialValue: T) => Form<T> = <
  T extends GenericObject,
>(
  initialValue: T,
) => {
  const form = vUseForm<T>({
    initialValues: initialValue as PartialDeep<T>,
  });

  const isValid = computed(() => {
    return form.meta.value.valid;
  });

  const formValues = computed(() => {
    return form.values;
  });

  return {
    isValid,
    formValues,
    vForm: form,
  };
};
